import {Link} from "react-router-dom";

const AllBlogs = ({isBg, bookData}) => {
  return (
    <section
      id="books"
      className={`section-padding blog ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        {bookData.blog.title && (
          <div className="row mt-5">
            <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
              <div className="section-title-center text-center">
                <span>Choose a book to</span>
                <h2 className="display-6">meet the characters</h2>
                <div className="section-divider divider-traingle"></div>
              </div>
            </div>
          </div>
        )}

        <div className="row">
          {bookData.blog.blogList.slice(0, 6).map((data, i) => (
            <div
              key={i}
              className="col-md-6 col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay={(i + 2) * 50}
            >
              <article className="blog__single-post h-100 translateEffect1">
                <div className="blog__single-post__image">
                  <Link
                    to={`/${bookData.blog.title ? "characters" : "books"}/${
                      data.slug
                    }`}
                  >
                    <img className="img-fluid" src={data.image} alt="Blog 01" />
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AllBlogs;
